'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableConfirmation: {
            type: Boolean | String | Function,
            kComposite: 'editable.confirmation'
        },
        editableCancelDelete: {
            type: String,
            kComposite: 'editable.cancelDelete'
        },
        editableConfirmDelete: {
            type: String,
            kComposite: 'editable.confirmDelete'
        },
        editableCreateAt: {
            type: String,
            kComposite: 'editable.createAt'
        },
        editableDestroy: {
            type: Boolean,
            kComposite: 'editable.destroy'
        },
        editableMode: {
            type: String,
            kComposite: 'editable.mode'
        },
        editableTemplate: {
            type: String | Function,
            kComposite: 'editable.template'
        },
        editableUpdate: {
            type: Boolean,
            kComposite: 'editable.update'
        },
        editableWindow: {
            type: Object,
            kComposite: 'editable.window'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-grid-vue-wrapper/dist/es/KendoGrid/Editable.js
// module id = 462
// module chunks = 45